import api from "@/plugins/api/EntryPoint";

export default {
  async getIndications(params, callBackFn) {
    console.log("INDICATION HISTORY DATE POST PARAMS: " + JSON.stringify(params));
    await api.post(`indication/history-date`, params, callBackFn);
  },
};
